export default __webpack_public_path__ + "static/media/img-guide-06@3x.1770cf65.png";